(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8758],{

/***/ 14413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17028);
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7181);



const getNumberNewReview = async (projectId)=>{
    const path = "v1/comments/project/".concat(projectId, "/countreview");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_1__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_2__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GET */ .Z.GET, path, null, {});
    return response;
};
/* harmony default export */ __webpack_exports__["Z"] = (getNumberNewReview);


/***/ }),

/***/ 66353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getListFileReviewProject; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82898);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26509);





const getListFileReviewProject = async (project, params)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/media/project/".concat(project), "?".concat(query_string__WEBPACK_IMPORTED_MODULE_3__/* ["default"].stringify */ .Z.stringify(params, {
        skipNull: true
    })));
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET */ .Z.GET, path, null, {});
    return response;
};


/***/ }),

/***/ 40364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Loading.tsx


const Loading = (props)=>{
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("loading flex items-center gap-1", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "loading__dot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "loading__dot"
            })
        ]
    });
};
/* harmony default export */ var components_Loading = (Loading);

;// CONCATENATED MODULE: ./src/components/Button.tsx



function Button(param) {
    let { size ="large" , btnType ="outline" , color ="primary" , children , prefixIcon , suffixIcon , className , loading , ...otherProps } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx_m/* default */.Z)("meey-button ", prefixIcon ? "meey-button-prefix-icon" : "", suffixIcon ? "meey-button-suffix-icon" : "", children ? "" : "meey-button-icon-only", "meey-button-".concat(size), "meey-button-".concat(btnType), "meey-button-".concat(color), className),
        "aria-label": "".concat(children),
        name: "".concat(children),
        ...otherProps,
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loading, {
                className: "mr-2"
            }) : null,
            prefixIcon,
            children,
            suffixIcon
        ]
    });
}


/***/ }),

/***/ 71381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ MediaTypeEnum; }
/* harmony export */ });
var MediaTypeEnum;
(function(MediaTypeEnum) {
    MediaTypeEnum[MediaTypeEnum["IMAGE"] = 1] = "IMAGE";
    MediaTypeEnum[MediaTypeEnum["FILE"] = 2] = "FILE";
    MediaTypeEnum[MediaTypeEnum["VIDEO"] = 3] = "VIDEO";
    MediaTypeEnum[MediaTypeEnum["LINK"] = 4] = "LINK";
})(MediaTypeEnum || (MediaTypeEnum = {}));


/***/ }),

/***/ 57761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ VoteCategoryEnum; }
/* harmony export */ });
var VoteCategoryEnum;
(function(VoteCategoryEnum) {
    VoteCategoryEnum[VoteCategoryEnum[/** Vị trí */ "LOCATION"] = 1] = "LOCATION";
    VoteCategoryEnum[VoteCategoryEnum[/** Chi phí */ "EXPENSE"] = 2] = "EXPENSE";
    VoteCategoryEnum[VoteCategoryEnum[/** Pháp lý */ "LEGAL"] = 3] = "LEGAL";
    VoteCategoryEnum[VoteCategoryEnum[/** Dịch vụ */ "SERVICE"] = 4] = "SERVICE";
    VoteCategoryEnum[VoteCategoryEnum[/** Tiện ích */ "UTILITIES"] = 5] = "UTILITIES";
    VoteCategoryEnum[VoteCategoryEnum[/** Chủ đầu tư */ "INVESTOR"] = 6] = "INVESTOR";
    VoteCategoryEnum[VoteCategoryEnum[/** BQL Dự án */ "PROJECT"] = 7] = "PROJECT";
    VoteCategoryEnum[VoteCategoryEnum[/** Chất lượng */ "QUALITY"] = 8] = "QUALITY";
})(VoteCategoryEnum || (VoteCategoryEnum = {}));


/***/ }),

/***/ 7181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ NO_SEO_ROBOTS_CONTENT; },
/* harmony export */   "E5": function() { return /* binding */ APP_BASE_URL; },
/* harmony export */   "HG": function() { return /* binding */ MEEY_REVIEW_API_URL; },
/* harmony export */   "TY": function() { return /* binding */ APP_MEEYPROJECT_URL; },
/* harmony export */   "XV": function() { return /* binding */ CAPCHA_KEY; },
/* harmony export */   "eR": function() { return /* binding */ MEDIA_URL; },
/* harmony export */   "f6": function() { return /* binding */ FB_APP_ID; },
/* harmony export */   "lc": function() { return /* binding */ API_MEDIA_URL; },
/* harmony export */   "vp": function() { return /* binding */ MESSENGER_APPID; },
/* harmony export */   "wz": function() { return /* binding */ APP_DOMAIN; },
/* harmony export */   "xm": function() { return /* binding */ STATIC_DOMAIN; }
/* harmony export */ });
/* unused harmony exports APP_ADMIN_URL, MEEY_PROJECT_API_URL, MEEY_SEO_API_URL, MEEY_HOME_API_URL, ALLOW_ROBOTS, SDK_URL, GTM_CODE, ENABLE_GTM */
/* provided dependency */ var process = __webpack_require__(34155);
const APP_BASE_URL = "https://meeyreview.com" || 0;
const APP_ADMIN_URL = (/* unused pure expression or super */ null && ("https://admin-meeyreview.meey.dev" || 0));
const APP_DOMAIN = process.env.APP_DOMAIN || "";
const STATIC_DOMAIN = "https://st.meeyreview.com" || 0;
const MEEY_PROJECT_API_URL = process.env.MEEY_PROJECT_API_URL || "";
const APP_MEEYPROJECT_URL = "https://meeyproject.com" || 0;
const MESSENGER_APPID = "519811362992559" || 0;
const MEEY_REVIEW_API_URL = "https://api.meeyreview.com" || 0;
const MEEY_SEO_API_URL = process.env.MEEY_SEO_API_URL || "";
const API_MEDIA_URL = "https://api.meeymedia.com" || 0;
const MEDIA_URL = "https://io.meeymedia.com" || 0;
const MEEY_HOME_API_URL = process.env.MEEY_HOME_API_URL || "";
const NO_SEO_ROBOTS_CONTENT = "false" === "true";
const ALLOW_ROBOTS = (/* unused pure expression or super */ null && ("Disallow" || 0));
const FB_APP_ID =  false || "";
const SDK_URL = (/* unused pure expression or super */ null && ("https://sdk.meeyid.com/sdk/js/sdk.js" || 0));
//tracking ga
const GTM_CODE = (/* unused pure expression or super */ null && ("GTM-5XGDKTZ" || 0));
const ENABLE_GTM = (/* unused pure expression or super */ null && ("true" === "true"));
const CAPCHA_KEY = "6LdVy28nAAAAAMyV7cA4K_AwXqv5MhyJ9moIvOUg";


/***/ }),

/***/ 32336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ fileType; }
/* harmony export */ });
const fileType = {
    image: /\.(jpg|jpeg|png|bmp|heic|heif|tiff|svg|psd|webp|avif)$/i,
    video: /\.(mp4|avi|mkv|wmv|vob|flv|wmv9|mpeg|3gp|webm|hevc|mov|mpg|3gpp|mpeg1|mpeg2|mpeg4|mpegps)$/i,
    file: /\.(pdf|xlsx|xls|doc|docx|pptx|dwg|kmz|wma)$/i,
    viewFileSupport: /\.(pdf|xlsx|xls|doc|docx|pptx)$/i,
    resizeImageSupport: /\.(jpg|jpeg|png)$/i
};


/***/ }),

/***/ 24435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ RESIZE_IMAGE; },
/* harmony export */   "Af": function() { return /* binding */ ZaloIcon; },
/* harmony export */   "LY": function() { return /* binding */ NOT_FOUND_PROJECT_IMAGE; },
/* harmony export */   "TI": function() { return /* binding */ CopyIcon; },
/* harmony export */   "Vq": function() { return /* binding */ FacebookIcon; },
/* harmony export */   "YG": function() { return /* binding */ TelegramIcon; },
/* harmony export */   "_D": function() { return /* binding */ DEFAULT_USER_AVATAR; },
/* harmony export */   "mG": function() { return /* binding */ DEFAULT_IMAGE_URI; },
/* harmony export */   "mq": function() { return /* binding */ DEFAULT_IMAGE_CARD; },
/* harmony export */   "qA": function() { return /* binding */ MessengerIcon; },
/* harmony export */   "yB": function() { return /* binding */ WhatsAppIcon; }
/* harmony export */ });
/* unused harmony exports MAX_IMAGE_CARD, ViberIcon */
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7181);

const DEFAULT_IMAGE_URI = "/meeyproject-test/images/2022/12/20/banner-home.1671526397059.jpg";
const DEFAULT_IMAGE_CARD = _environment__WEBPACK_IMPORTED_MODULE_0__/* .STATIC_DOMAIN */ .xm + "/anonymous.svg";
const DEFAULT_USER_AVATAR = "images/default_user_avatar.svg";
const MAX_IMAGE_CARD = 10;
const RESIZE_IMAGE = {
    default: {
        width: 720,
        height: 540
    },
    card: {
        width: 404,
        height: 270
    },
    cardMobile: {
        width: 382,
        height: 254
    },
    cardHorizontal: {
        width: 320,
        height: 180
    },
    cardProject: {
        width: 618,
        height: 412
    },
    bannerDesktop: {
        width: 1920,
        height: 612
    },
    bannerMobile: {
        width: 414,
        height: 200
    },
    cardProjectMobile: {
        width: 382,
        height: 255
    },
    cardNews: {
        width: 281,
        height: 168
    },
    cardNewsFeatured: {
        width: 487,
        height: 292
    },
    cardArticleHorizontal: {
        width: 404,
        height: 270
    },
    cardArticleHorizontalFeature: {
        width: 404,
        height: 560
    },
    cardArticleDetail: {
        width: 459,
        height: 274
    },
    projectInfo: {
        width: 249,
        height: 149
    },
    cardArticleByLocation: {
        width: 183,
        height: 183
    }
};
const NOT_FOUND_PROJECT_IMAGE = "/building.svg";
const CopyIcon = "/images/social/copy.svg";
const FacebookIcon = "/images/social/facebook.svg";
const MessengerIcon = "/images/social/messenger.svg";
const ZaloIcon = "/images/social/zalo.svg";
const WhatsAppIcon = "/images/social/whatsapp.svg";
const TelegramIcon = "/images/social/telegram.svg";
const ViberIcon = "/images/social/viber.svg";


/***/ }),

/***/ 20691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CC": function() { return /* binding */ PAGE_SIZE_REVIEWS; },
/* harmony export */   "Ew": function() { return /* binding */ PAGE_SIZE_FILE; },
/* harmony export */   "iO": function() { return /* binding */ PAGE_SIZE_REPLY; },
/* harmony export */   "su": function() { return /* binding */ LIMIT_DATALOAD_LIST; },
/* harmony export */   "yH": function() { return /* binding */ PAGE_SIZE_LIST_SEARCH; }
/* harmony export */ });
/* unused harmony exports MIN_ROUND_NUMBER, PAGE_SIZE, LIMIT_PROVINCE, LIMIT_LOCATION, PAGE_INDEX, MAX_PAGE, LIMIT_PAGE_INDEX, FEATURE_ARTICLE_LISTING, MAX_LENGTH_DESCRIPTION, LIMIT_FEATURE_PROJECT_HOME, LIMIT_RELATED_ARTICLE, LIMIT_RELATED_PROJECT, LIMIT_RELATED_ARTICLE_MOBILE, NUMBER_SKELETON_ARTICLE, SAVED_ARTICLE_PAGING, WATCHED_ARTICLE_PAGING, LIMIT_NEWS_FEATURE, LIMIT_FEATURE_PROJECT, LIMIT_FEATURE_PROJECT_LISTING */
const MIN_ROUND_NUMBER = 0.5;
const LIMIT_DATALOAD_LIST = 10;
const PAGE_SIZE = 30;
const LIMIT_PROVINCE = 100;
const LIMIT_LOCATION = 500;
const PAGE_INDEX = 0;
const MAX_PAGE = 50000;
const LIMIT_PAGE_INDEX = 50000;
const FEATURE_ARTICLE_LISTING = 2;
const MAX_LENGTH_DESCRIPTION = 150;
const LIMIT_FEATURE_PROJECT_HOME = 5;
const LIMIT_RELATED_ARTICLE = 12;
const LIMIT_RELATED_PROJECT = 6;
const LIMIT_RELATED_ARTICLE_MOBILE = 10;
const NUMBER_SKELETON_ARTICLE = 10;
const SAVED_ARTICLE_PAGING = 3;
const WATCHED_ARTICLE_PAGING = 5;
const LIMIT_NEWS_FEATURE = 4;
const LIMIT_FEATURE_PROJECT = 6;
const LIMIT_FEATURE_PROJECT_LISTING = 6;
const PAGE_SIZE_REVIEWS = 30;
const PAGE_SIZE_REPLY = 10;
const PAGE_SIZE_FILE = 30;
const PAGE_SIZE_LIST_SEARCH = 20;


/***/ }),

/***/ 18825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ DEFAULT_LOGO_PROJECT; },
/* harmony export */   "K2": function() { return /* binding */ RATE_CATEGORY; },
/* harmony export */   "mG": function() { return /* binding */ DEFAULT_IMAGE_URI; }
/* harmony export */ });
/* unused harmony exports MAX_LIST_FILE_SHOW, PROJECT_PROPERTIES, PROJECT_PROPERTIES_LABEL, DOCUMENT_RELATED, PROJECT_RELATED_VIDEO, JURIDICAL_DOCUMENTS */
/* harmony import */ var _enum_vote__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57761);

const MAX_LIST_FILE_SHOW = 10;
const PROJECT_PROPERTIES = {
    PROECT_TITLE: "title",
    PROJECT_TYPES: "projectTypes",
    STATUS: "handoverProgress",
    // PROGRESS: 'progress',
    //INVESTOR: 'investor',
    LOCATION: "location",
    //OPERATING_UNIT: 'operatingUnit',
    BUILD_DENSITY: "buildingDensity",
    OWNER_SHIP: "ownership",
    TOTAL_BUILDING: "totalBuilding",
    TOTAL_FLOOR: "totalFloor",
    TOTAL_APARTMENT: "totalApartment",
    // LEGAL: 'legal',
    START_TIME: "startTime",
    COMPLETION_TIME: "completionTime",
    PRICE: "price",
    AREA: "AREA"
};
const PROJECT_PROPERTIES_LABEL = {
    [PROJECT_PROPERTIES.PROECT_TITLE]: "T\xean dự \xe1n",
    [PROJECT_PROPERTIES.PROJECT_TYPES]: "Loại dự \xe1n",
    [PROJECT_PROPERTIES.STATUS]: "Trạng th\xe1i dự \xe1n",
    [PROJECT_PROPERTIES.STATUS]: "Tiến độ b\xe0n giao",
    //INVESTOR: 'investor',
    [PROJECT_PROPERTIES.LOCATION]: "Vị tr\xed",
    //OPERATING_UNIT: 'operatingUnit',
    [PROJECT_PROPERTIES.BUILD_DENSITY]: "Mật độ x\xe2y dựng",
    [PROJECT_PROPERTIES.OWNER_SHIP]: "H\xecnh thức sở hữu",
    [PROJECT_PROPERTIES.TOTAL_BUILDING]: "Số t\xf2a",
    [PROJECT_PROPERTIES.TOTAL_FLOOR]: "Số tầng",
    [PROJECT_PROPERTIES.TOTAL_APARTMENT]: "Số căn",
    // LEGAL: 'legal',
    [PROJECT_PROPERTIES.START_TIME]: "Thời gian khởi c\xf4ng",
    [PROJECT_PROPERTIES.COMPLETION_TIME]: "Thơi gian ho\xe0n th\xe0nh",
    [PROJECT_PROPERTIES.PRICE]: "Mức gi\xe1 từ",
    [PROJECT_PROPERTIES.AREA]: "Diện t\xedch"
};
const DOCUMENT_RELATED = {
    BANK: "bank",
    CONSTRUCTION_UNIT: "constructionUnit",
    OPERATING_UNIT: "operatingUnit",
    DISTRIBUTION_UNIT: "distributionUnit"
};
const PROJECT_RELATED_VIDEO = {
    DEFAULT_LIMIT_DESKTOP: 4,
    DEFAULT_LIMIT_TABLET: 6,
    DEFAULT_LIMIT_MOBILE: 5,
    LIMIT_LOAD_MORE_DESKTOP: 4,
    LIMIT_LOAD_MORE_TABLET: 3,
    LIMIT_LOAD_MORE_MOBILE: 5,
    LIMIT_MAX_VIDEO: 60
};
const JURIDICAL_DOCUMENTS = {
    BUSINESS_LICENSE: "businessLicense",
    CONSTRUCTION_PERMIT: "constructionPermit",
    HANDOVER_DECISION: "handoverDecision",
    RESPONSIBLE_FOR_COLLECTION_FOUNDATION: "responsibleForCollectingFoundation",
    OWNER_SHIP_CERTIFICATE: "ownershipCertificate",
    BANK_GUARANTEE: "bankGuarantee",
    APPROVE1_500: "approve1_500",
    OTHER_DOCS: "otherDocs"
};
const DEFAULT_IMAGE_URI = "/meeycrm-v3-test/images/2023/06/07/202302021420517b57wm.1686126016669.jpg";
const RATE_CATEGORY = [
    {
        title: "Vị tr\xed",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.LOCATION */ .k.LOCATION
    },
    {
        title: "Tiện \xedch",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.UTILITIES */ .k.UTILITIES
    },
    {
        title: "Gi\xe1 b\xe1n",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.EXPENSE */ .k.EXPENSE
    },
    {
        title: "Chất lượng ",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.QUALITY */ .k.QUALITY
    },
    {
        title: "Dịch vụ",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.SERVICE */ .k.SERVICE
    },
    {
        title: "BQL dự \xe1n",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.PROJECT */ .k.PROJECT
    },
    {
        title: "Ph\xe1p l\xfd",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.LEGAL */ .k.LEGAL
    },
    {
        title: "Chủ đầu tư",
        key: _enum_vote__WEBPACK_IMPORTED_MODULE_0__/* .VoteCategoryEnum.INVESTOR */ .k.INVESTOR
    }
];
const DEFAULT_LOGO_PROJECT = "images/default_avatar_project.jpg";


/***/ }),

/***/ 17028:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    GET: "get",
    POST: "post",
    DELETE: "delete",
    PUT: "put",
    PATCH: "patch",
    HEAD: "head",
    options: "options"
});


/***/ }),

/***/ 12482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ProjectContextProvider; },
/* harmony export */   "x": function() { return /* binding */ ProjectContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _api_endpoint_project_get_number_new_review__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14413);
/* harmony import */ var _api_endpoint_reviews_get_list_file_review_project__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66353);
/* harmony import */ var _constants_enum_media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71381);
/* harmony import */ var _constants_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20691);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);






const ProjectContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)({
    project: null,
    projectListVote: {
        page: 1,
        totalPages: 0,
        totalResults: 0,
        results: []
    },
    listReplyVote: {},
    projectListFile: {
        page: 1,
        totalPages: 0,
        totalResults: 0,
        results: []
    }
});
function ProjectContextProvider(props) {
    const { children , ...rest } = props;
    const [project, setProject] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.project);
    const [projectVideos, setProjectVideos] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.projectVideos);
    const [projectListVote, setProjectListVote] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.projectListVote);
    const [projectListFile, setProjectListFile] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.projectListFile);
    const [currentShowFormReply, setCurrentShowFormReply] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null);
    const [currentShowFormReport, setCurrentShowFormReport] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null);
    const [listReplyVote, setListReplyVote] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({});
    const [selectedVoteFiles, setSelectedVoteFiles] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null);
    // set selected file for right content
    const [selectedViewFiles, setSelectedViewFiles] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null);
    const [checkFollowProject, setCheckFollowProject] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [loadingLike, setLoadingLike] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [loadingDisLike, setLoadingDisLike] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [loadingSendReply, setLoadingSendReply] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [numberNewReview, setNumberNewReview] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.numberNewReview);
    const [reviewDetail, setReviewDetail] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(rest.reviewDetail);
    const [topFileMedia, setTopFileMedia] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const [listReviewsIds, setListReviewIds] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const [listReviewReactions, setListReviewReactions] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const refUpload = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const currentRefItem = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setProjectListVote(rest.projectListVote);
        if (rest === null || rest === void 0 ? void 0 : rest.projectListVote) {
            var _rest_projectListVote, _rest_projectListVote_results;
            let listIds = [];
            (_rest_projectListVote = rest.projectListVote) === null || _rest_projectListVote === void 0 ? void 0 : (_rest_projectListVote_results = _rest_projectListVote.results) === null || _rest_projectListVote_results === void 0 ? void 0 : _rest_projectListVote_results.map((item)=>{
                var _item_replies;
                listIds.push(item === null || item === void 0 ? void 0 : item._id);
                if ((_item_replies = item.replies) === null || _item_replies === void 0 ? void 0 : _item_replies.length) {
                    item.replies.map((rep)=>{
                        listIds.push(rep._id);
                    });
                }
            });
            setListReviewIds(listIds);
            setListReplyVote({});
        }
    }, [
        rest.projectListVote
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setReviewDetail(rest.reviewDetail);
        if (rest === null || rest === void 0 ? void 0 : rest.reviewDetail) {
            var _rest_reviewDetail_, _rest_reviewDetail_1, _rest_reviewDetail__replies;
            let listIds = [];
            listIds.push((_rest_reviewDetail_ = rest === null || rest === void 0 ? void 0 : rest.reviewDetail[0]) === null || _rest_reviewDetail_ === void 0 ? void 0 : _rest_reviewDetail_._id);
            if ((_rest_reviewDetail_1 = rest.reviewDetail[0]) === null || _rest_reviewDetail_1 === void 0 ? void 0 : (_rest_reviewDetail__replies = _rest_reviewDetail_1.replies) === null || _rest_reviewDetail__replies === void 0 ? void 0 : _rest_reviewDetail__replies.length) {
                var _rest_reviewDetail_2, _rest_reviewDetail__replies1;
                (_rest_reviewDetail_2 = rest.reviewDetail[0]) === null || _rest_reviewDetail_2 === void 0 ? void 0 : (_rest_reviewDetail__replies1 = _rest_reviewDetail_2.replies) === null || _rest_reviewDetail__replies1 === void 0 ? void 0 : _rest_reviewDetail__replies1.map((item)=>{
                    listIds.push(item === null || item === void 0 ? void 0 : item._id);
                });
            }
            setListReviewIds(listIds);
        }
    }, [
        rest.reviewDetail
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setProject(rest.project);
        setProjectListFile(rest.projectListFile);
        setNumberNewReview(rest.numberNewReview);
    }, [
        rest.project,
        rest.project._id,
        rest.projectListFile,
        rest.numberNewReview
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (rest.projectListFile) {
            var _rest_projectListFile;
            setTopFileMedia(rest === null || rest === void 0 ? void 0 : (_rest_projectListFile = rest.projectListFile) === null || _rest_projectListFile === void 0 ? void 0 : _rest_projectListFile.results);
        }
    }, [
        rest.projectListFile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setProjectVideos(rest.projectVideos);
    }, [
        rest.projectVideos
    ]);
    const handleSyncNumberReview = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(async ()=>{
        try {
            const resListFile = await (0,_api_endpoint_reviews_get_list_file_review_project__WEBPACK_IMPORTED_MODULE_2__/* .getListFileReviewProject */ .c)(project === null || project === void 0 ? void 0 : project._id, {
                type: "".concat(_constants_enum_media__WEBPACK_IMPORTED_MODULE_3__/* .MediaTypeEnum.IMAGE.toString */ .L.IMAGE.toString(), ",").concat(_constants_enum_media__WEBPACK_IMPORTED_MODULE_3__/* .MediaTypeEnum.VIDEO.toString */ .L.VIDEO.toString(), ",").concat(_constants_enum_media__WEBPACK_IMPORTED_MODULE_3__/* .MediaTypeEnum.FILE.toString */ .L.FILE.toString()),
                page: 1,
                limit: _constants_number__WEBPACK_IMPORTED_MODULE_5__/* .PAGE_SIZE_FILE */ .Ew
            });
            if (resListFile) {
                setProjectListFile(resListFile);
                setTopFileMedia(resListFile === null || resListFile === void 0 ? void 0 : resListFile.results);
            }
            const res = await (0,_api_endpoint_project_get_number_new_review__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(project._id);
            setNumberNewReview(res);
        } catch (error) {
            console.log(error);
        }
    }, [
        project
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProjectContext.Provider, {
        value: {
            ...rest,
            projectListVote: projectListVote,
            selectedVoteFiles,
            listReplyVote,
            selectedViewFiles,
            projectListFile,
            project,
            checkFollowProject,
            numberNewReview,
            reviewDetail,
            currentShowFormReply,
            loadingLike,
            loadingDisLike,
            topFileMedia,
            listReviewsIds,
            listReviewReactions,
            refUpload,
            loadingSendReply,
            currentShowFormReport,
            projectVideos,
            setProjectVideos,
            setCurrentShowFormReport,
            setLoadingSendReply,
            setCurrentShowFormReply,
            setListReplyVote,
            setSelectedVoteFiles,
            setProjectListVote,
            setSelectedViewFiles,
            setProjectListFile,
            setProject,
            setCheckFollowProject,
            setNumberNewReview,
            setReviewDetail,
            handleSyncNumberReview,
            setLoadingLike,
            setLoadingDisLike,
            setTopFileMedia,
            setListReviewIds,
            setListReviewReactions,
            currentRefItem
        },
        children: props.children
    });
}


/***/ }),

/***/ 77325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ isImageFile; },
/* harmony export */   "Li": function() { return /* binding */ resizeOnFlyUrl; },
/* harmony export */   "NU": function() { return /* binding */ isVideoFile; }
/* harmony export */ });
/* unused harmony export isDocFile */
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32336);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81354);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
const path = __webpack_require__(1864);


const replaceSafeBase64 = (input)=>{
    return input.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
// resize on the fly
const urlSafeBase64 = (str)=>{
    return replaceSafeBase64(Buffer.from(str).toString("base64"));
};
const sign = (salt, target, secret)=>{
    const hmac = crypto_js__WEBPACK_IMPORTED_MODULE_1___default().algo.HMAC.create((crypto_js__WEBPACK_IMPORTED_MODULE_1___default().algo.SHA256), crypto_js__WEBPACK_IMPORTED_MODULE_1___default().enc.Hex.parse(secret));
    hmac.update(crypto_js__WEBPACK_IMPORTED_MODULE_1___default().enc.Hex.parse(salt));
    hmac.update(target);
    return replaceSafeBase64(hmac.finalize().toString((crypto_js__WEBPACK_IMPORTED_MODULE_1___default().enc.Base64)));
};
const config = {
    resize: {
        key: "81d04ff7ceb59c154647cbb173751d137ec6bf059f30b37d37ec043e4c859639",
        salt: "5a71c31c96ec7650b883aa294d89d1b38e5918bee141b977e18db43fc09552bc",
        domain: "https://i.meeymedia.com",
        domainWatermark: "https://i-homes.meeymedia.com"
    }
};
const resizeOnFlyUrl = (resizeBody)=>{
    var _path_extname;
    const { width , height , resizingType , uri , gravity , watermark =false  } = resizeBody || {};
    const resizeType = resizingType === "crop" ? resizingType : "rs:".concat(resizingType);
    const KEY = config.resize.key;
    const SALT = config.resize.salt;
    const domain = watermark && config.resize.domainWatermark ? config.resize.domainWatermark : config.resize.domain;
    const sourceImage = "s3:/".concat(uri);
    const extension = (_path_extname = path.extname(sourceImage)) === null || _path_extname === void 0 ? void 0 : _path_extname.toLowerCase();
    const encodedUrl = urlSafeBase64(sourceImage);
    const pathGenerate = watermark ? "/".concat(resizeType, ":").concat(width, ":").concat(height, "/g:").concat(gravity, "/watermark:0.5:ce:0:0:0.2/").concat(encodedUrl).concat(extension) : "/".concat(resizeType, ":").concat(width, ":").concat(height, "/g:").concat(gravity, "/").concat(encodedUrl).concat(extension);
    const signature = sign(SALT, pathGenerate, KEY);
    return "".concat(domain, "/").concat(signature).concat(pathGenerate);
};
const isImageFile = (name)=>name.match(_constants_file__WEBPACK_IMPORTED_MODULE_0__/* .fileType.image */ .r.image);
const isDocFile = (name)=>name.match(fileType.file);
const isVideoFile = (name)=>name.match(_constants_file__WEBPACK_IMPORTED_MODULE_0__/* .fileType.video */ .r.video);


/***/ }),

/***/ 67650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "US": function() { return /* reexport */ convertAddress; },
  "NL": function() { return /* reexport */ convertAddressNoStreet; },
  "CO": function() { return /* reexport */ utils_image/* isImageFile */.CO; },
  "NU": function() { return /* reexport */ utils_image/* isVideoFile */.NU; },
  "Li": function() { return /* reexport */ utils_image/* resizeOnFlyUrl */.Li; },
  "Jm": function() { return /* reexport */ skipNullParams; },
  "U": function() { return /* reexport */ voteCategoryColor; }
});

// UNUSED EXPORTS: copyToClipBoard, emptyChecker, fomartNumberSpretor, getAvatarName, getShortId, isDocFile, isExpiredDate, isServer, isTouchDevice, objectToGetParams, renderingText, shortAddress

;// CONCATENATED MODULE: ./src/utils/common.ts
function emptyChecker(mixedVar) {
    let emptyValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        undefined,
        null,
        ""
    ];
    let i, len;
    for(i = 0, len = emptyValues.length; i < len; i++){
        if (mixedVar === emptyValues[i]) {
            return true;
        }
    }
    if (typeof mixedVar === "object") {
        for (const item of Object.values(mixedVar)){
            if (!emptyChecker(item, emptyValues)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
const isServer = (/* unused pure expression or super */ null && ("object" === "undefined"));
const getShortId = (slug)=>Number(slug.split("-").pop());
const renderingText = (label, suffix, prefix)=>!label ? "---" : "".concat(prefix ? prefix + " " : "").concat(label).concat(suffix ? " " + suffix : "");
const objectToGetParams = (object)=>{
    const params = Object.entries(object).filter((param)=>{
        let [, value] = param;
        return value !== undefined && value !== null;
    }).map((param)=>{
        let [key, value] = param;
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join("&")) : "";
};
const getAvatarName = (name)=>{
    return name === null || name === void 0 ? void 0 : name.split(" ").slice(-1).join(" ").charAt(0).toUpperCase();
};
const copyToClipBoard = (text, callback, fallback)=>{
    if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(text).then(()=>{
            if (callback) {
                callback();
                return;
            }
        }).catch((err)=>{
            fallback && fallback(err);
        });
    }
};
const isTouchDevice = ()=>{
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
const isExpiredDate = (date)=>{
    return new Date(date).getTime() <= new Date().getTime();
};
const fomartNumberSpretor = (val, spreator)=>{
    var withCommas = [];
    const valString = val ? "".concat(val) : "";
    for(var i = valString.length - 1; i >= 0; i--){
        withCommas.push(valString[i]);
        if ((valString.length - i) % 3 === 0 && i !== 0) {
            withCommas.push(" ");
        }
    }
    return withCommas.reverse().join("");
};
const voteCategoryColor = (vote)=>{
    let color = "";
    switch(true){
        case vote < 2:
            color = "#CE3217";
            break;
        case vote >= 2 && vote < 3:
            color = "#FEA855";
            break;
        case vote >= 3 && vote < 4.5:
            color = "#65C764";
            break;
        default:
            color = "#27A435";
    }
    return color;
};
const skipNullParams = (data)=>{
    let editData = {};
    Object.keys(data).forEach((key)=>{
        if (data[key]) {
            editData[key] = data[key];
        }
    });
    return editData;
};

// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(77325);
;// CONCATENATED MODULE: ./src/utils/address.ts
const convertAddress = (addressObject)=>{
    var _wardTranslate_name, _districtTranslate_name, _cityTranslate_name;
    const streetTranslate = addressObject.street;
    const wardTranslate = addressObject.ward;
    const districtTranslate = addressObject.district;
    const cityTranslate = addressObject.city;
    return "".concat(addressObject.address ? addressObject.address : "", " ").concat((streetTranslate === null || streetTranslate === void 0 ? void 0 : streetTranslate.name.trim()) ? streetTranslate.name + "," : "", " ").concat((wardTranslate === null || wardTranslate === void 0 ? void 0 : (_wardTranslate_name = wardTranslate.name) === null || _wardTranslate_name === void 0 ? void 0 : _wardTranslate_name.trim()) ? (wardTranslate === null || wardTranslate === void 0 ? void 0 : wardTranslate.name) + "," : "", " \n  ").concat((districtTranslate === null || districtTranslate === void 0 ? void 0 : (_districtTranslate_name = districtTranslate.name) === null || _districtTranslate_name === void 0 ? void 0 : _districtTranslate_name.trim()) ? (districtTranslate === null || districtTranslate === void 0 ? void 0 : districtTranslate.name) + "," : "", " \n  ").concat((cityTranslate === null || cityTranslate === void 0 ? void 0 : (_cityTranslate_name = cityTranslate.name) === null || _cityTranslate_name === void 0 ? void 0 : _cityTranslate_name.trim()) ? cityTranslate === null || cityTranslate === void 0 ? void 0 : cityTranslate.name : "");
};
const convertAddressNoStreet = (addressObject)=>{
    var _wardTranslate_name, _districtTranslate_name, _cityTranslate_name;
    const wardTranslate = addressObject.ward;
    const districtTranslate = addressObject.district;
    const cityTranslate = addressObject.city;
    return "".concat(addressObject.address ? addressObject.address : "", " ").concat((wardTranslate === null || wardTranslate === void 0 ? void 0 : (_wardTranslate_name = wardTranslate.name) === null || _wardTranslate_name === void 0 ? void 0 : _wardTranslate_name.trim()) ? (wardTranslate === null || wardTranslate === void 0 ? void 0 : wardTranslate.name) + "," : "", " \n  ").concat((districtTranslate === null || districtTranslate === void 0 ? void 0 : (_districtTranslate_name = districtTranslate.name) === null || _districtTranslate_name === void 0 ? void 0 : _districtTranslate_name.trim()) ? (districtTranslate === null || districtTranslate === void 0 ? void 0 : districtTranslate.name) + "," : "", " \n  ").concat((cityTranslate === null || cityTranslate === void 0 ? void 0 : (_cityTranslate_name = cityTranslate.name) === null || _cityTranslate_name === void 0 ? void 0 : _cityTranslate_name.trim()) ? cityTranslate === null || cityTranslate === void 0 ? void 0 : cityTranslate.name : "");
};
const shortAddress = function(addressObject) {
    let showPrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
// if (!addressObject) return ''
// const districtTranslate = getTranslateItemByCurrentLanguage<
// 	Location,
// 	LocationTranslation
// >(addressObject.district)
// const cityTranslate = getTranslateItemByCurrentLanguage<
// 	Location,
// 	LocationTranslation
// >(addressObject.city)
// return `
// ${
// 	districtTranslate?.name?.trim()
// 		? (/^\d*$/.test(districtTranslate.name) || showPrefix
// 				? districtTranslate.prefix + ' '
// 				: '') +
// 		  districtTranslate?.name +
// 		  ','
// 		: ''
// }
// ${
// 	cityTranslate?.name?.trim()
// 		? (showPrefix ? cityTranslate.prefix + ' ' : '') + cityTranslate?.name
// 		: ''
// }`
};

;// CONCATENATED MODULE: ./src/utils/index.ts





/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);